<h2 mat-dialog-title>Conferma eliminazione</h2>
<p mat-dialog-content>Sei sicuro di eliminare l'elemento selezionato?</p>
<mat-dialog-actions align="end">
  <button matButton="outlined" (click)="chiudiDialog(0)">No</button>
  <button matButton="filled" color="primary" (click)="chiudiDialog(1)">Si</button>
</mat-dialog-actions>
